import { FormSelect, FormTextInput } from "@jsq/ds/forms";
import { SPACING } from "~/styles/variables";
import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import {
  amlRelianceLetterDocumentTypesArray,
  amlRelianceLetterMeetsRequirementsTypesArray,
} from "./constants";

interface Props {
  readonly: boolean;
}

const AMLRelianceLetterDocFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={amlRelianceLetterDocumentTypesArray}
        placeholder="Select an AML reliance letter document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <FormTextInput
        isFullWidth
        disabled={readonly}
        css={{ marginBottom: SPACING.MEDIUM }}
        name="nameOfIssuer"
        label="Name of issuer"
      />
      <FormTextInput
        isFullWidth
        disabled={readonly}
        css={{ marginBottom: SPACING.MEDIUM }}
        name="issuerRelationship"
        label="Issuer’s relationship to Subscriber"
      />
      <DateFieldFormValue
        label="Date of Issue/Signature"
        readonly={readonly}
        maxDate={new Date()}
        showExpiredWarning
      />
      <FormSelect
        css={{ marginBottom: SPACING.MEDIUM }}
        disabled={readonly}
        name="meetsRequirements"
        label="Meets Requirements"
        placeholder="Select an option"
        full
      >
        <FormSelect.Section>
          {amlRelianceLetterMeetsRequirementsTypesArray.map((type) => (
            <FormSelect.Option key={type.value} value={type.value}>
              {type.readableName}
            </FormSelect.Option>
          ))}
        </FormSelect.Section>
      </FormSelect>
    </>
  );
};

export default AMLRelianceLetterDocFormValues;
